export const GOVGR_BREADCRUMBS = "govgr-breadcrumbs";
export const GOVGR_BREADCRUMS__LIST = "govgr-breadcrumbs__list";
export const GOVGR_BREADCRUMBS__LIST_ITEM = "govgr-breadcrumbs__list-item";
export const GOVGR_BREADCRUMBS__LINK = "govgr-breadcrumbs__link";
